
import Vue from 'vue';
import Component from 'vue-class-component';
import ContractView from '@/components/contracts/ContractView.vue';
import ProjectDetails from '@/components/projects/ProjectDetails.vue';
import {
  LookupResponse,
  StatusResponse,
  PowerGridOperatorResponse,
} from '@/common/interfaces/meta';
import { ProjectItem } from '@/common/interfaces/project';
import { DebitorResponse } from '@/common/interfaces/debitor';
import { UserinfoResponse } from '@/common/interfaces/auth';

@Component({
  components: {
    ContractView,
    ProjectDetails,
  },
})
export default class Contracts extends Vue {
  get status(): StatusResponse[] {
    return this.$store.getters.statusData;
  }

  get documentTypes(): DocumentType[] {
    return this.$store.getters.documentTypesData;
  }

  get lookup(): LookupResponse[] {
    return this.$store.getters.lookupData;
  }

  get projects(): ProjectItem[] {
    return this.$store.getters.projectsData;
  }

  get debitors(): DebitorResponse[] {
    return this.$store.getters.debitorData;
  }

  get powerGridOperators(): PowerGridOperatorResponse[] {
    return this.$store.getters.powerGridOperatorData;
  }

  get userInfo(): UserinfoResponse | null {
    return this.$store.getters.userInfoData;
  }

  mounted() {
    if (!this.status.length) {
      this.$store.dispatch('getStatus');
    }
    if (!this.documentTypes.length) {
      this.$store.dispatch('getDocumentTypes');
    }
    if (!this.lookup.length) {
      this.$store.dispatch('getLookup');
    }
    if (!this.projects.length) {
      this.$store.dispatch('getProjects');
    }
    if (!this.powerGridOperators.length) {
      this.$store.dispatch('getPowerGridOperator');
    }
    if (!this.debitors.length) {
      this.$store.dispatch('getDebitors');
    }
    if (this.userInfo === null) {
      this.$store.dispatch('getUserInfo');
    }

    this.$store.commit('resetProjectSelected');
    this.$store.commit('resetContractDetails');
    this.$store.dispatch('getContracts', false);

    if (this.$route.params.id !== undefined) {
      // Select contract
      this.$store.dispatch('getContractDetails', this.$route.params.id);
    }
  }
}
